import { render, staticRenderFns } from "./childVariant.vue?vue&type=template&id=74578e01"
import script from "./childVariant.vue?vue&type=script&lang=js"
export * from "./childVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports